import { combineReducers } from "redux";

// Front
import Layout from "./layout/reducer";

// Authentication
import Login from "./auth/login/reducer";
import googleLogin from "./auth/googleLogin/reducer";
import Account from "./auth/register/reducer";
import ChangePassword from "./auth/changepwd/reducer";
import ForgetPassword from "./auth/forgetpwd/reducer";
import Profile from "./auth/profile/reducer";

// Points
import points from "./points/reducer";

// StoreMenu
import storeMenu from "./storeMenu/reducer";

// StoreDetails
import storeDetails from "./storeDetails/reducer";

// TopicDetails
import topicDetails from "./topicDetails/reducer";

// QuestionsSetDetails
import questionSetDetails from "./questionSetDetails/reducer";

// InfoProfile
import infoProfile from "./infoProfile/reducer";

// Followers
import followers from "./followers/reducer";

// imageMap
import imageMap from "./imageMap/reducer";

// user
import user from "./user/reducer";

const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  googleLogin,
  Account,
  ChangePassword,
  ForgetPassword,
  Profile,
  points,
  storeMenu,
  storeDetails,
  topicDetails,
  questionSetDetails,
  infoProfile,
  followers,
  imageMap,
  user,
});

export default rootReducer;
